import { Directive, Input } from "@angular/core";

@Directive({
    selector: '[prevent-keys]',
    host: {
        '(keydown)': 'onKeyUp($event)'
    }
})
export class PreventKeysDirective {

    @Input('prevent-keys') preventKeys: string = null;

    public onKeyUp($event): void {
        if (!this.preventKeys)
            return;
        let regex = RegExp(this.preventKeys);
        if ($event.keyIdentifier <= 46 || $event.keyCode <= 46)
            return;
        if (Array.isArray(this.preventKeys)) {
            if (!this.preventKeys.includes($event.keyCode))
                $event.preventDefault();
            return;
        }
        if (!regex.test($event.key))
            $event.preventDefault();
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/prevent-keys.directive.ts